module.exports = __webpack_public_path__ + "img/Scratch_Win_Vector.c4112dd2.png";